<script>
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwPassword from '@/components/generic/forms/tw-password.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwCheckbox from '@/components/generic/forms/tw-checkbox.vue'
import { mapActions } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'

export default {
  name: 'LoginForm',
  components: { TwCheckbox, TwButton, TwValidationErrors, TwPassword, TwInput },

  props: {
    noRedirect: {
      type: Boolean,
      default:false
    },
    noLabels: {
      type: Boolean,
      default:false
    },
  },
  emits: ['userLoggedIn'],
  data() {
    return {
      ValidationErrorMessage: null,
      Loading: false,
      LoginEmail: null,
      LoginPassword: null,
      LoginRemember:false,
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['attempt_user', 'set_user','login']),
    async loginSubmit() {
      try {
        this.ValidationErrorMessage = null
        await this.login({
          email: this.LoginEmail,
          password: this.LoginPassword,
          remember: this.LoginRemember
        }, this.noRedirect)
        this.$emit('userLoggedIn')
      } catch (e) {
        if(e.response) {
          this.ValidationErrorMessage = e.response.data
        }
      }
    },
  },
}
</script>

<template>
  <form @submit.prevent="loginSubmit">
    <slot name="above" />
    <tw-input v-model="LoginEmail" :label="noLabels ? null : 'Email or username:'" />
    <tw-password v-model="LoginPassword" :label="noLabels? null: 'Password:'" class="mt-6 mb-4" />
    <router-link :to="{ name: 'ForgotPassword' }" class="text-sm float-right text-gray-600 hover:underline">
      Forgot your password?
    </router-link>
    <tw-checkbox v-model="LoginRemember" label="Remember me" />
    <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
    <div class="clear-both mt-6" />
    <div class="flex justify-end">
      <tw-button block @click="loginSubmit">
        Login
      </tw-button>
    </div>
  </form>
</template>

<style scoped>

</style>
